//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Service from '@/service/building'
import { sendCtmEvtLog } from '@/utils/log'
import log_mixins from '@/common/mixins/log'
import { mapHouseItem } from '@/common/utils/map_view_data'
import { debounce } from '@/utils'
import PoiList from './_poi_list'
import QqMap from '@/components/views/map'
import { TYPES, DETS_ICONS, HOUSE_ICON, DEFAULT_DEST_ICON, DETS_A_ICONS } from '../_const'

import BusinessBuildingService from '@/service/business_building'
import BuildingService from '@/service/building'
import ConsultTip from '../_consult_tip'
import consult from '../consult'

let PageData = {}

const MapData = {
    ctx: null,
    HouseMarker: null,
    reset () {
        this.ctx = null
        this.HouseMarker = null
    }
}

const MAIN_CALLOUT = {
    color: '#ffffff',
    fontSize: '14px',
    bgColor: '#00B800',
    display: 'ALWAYS',
    borderRadius: '22.5px',
    boxShadow: '0 1px 2px 0 rgba(125, 100, 72, .3)',
    padding: '8px',
    textAlign: 'center',
    border: 0,
    zIndex: 10
}
const NORMAL_CALLOUT = {
    color: '#ffffff',
    fontSize: '14px',
    bgColor: '#00AD82',
    display: 'ALWAYS',
    borderRadius: '22.5px',
    boxShadow: '0 1px 2px 0 rgba(164, 100, 72, .3)',
    border: 0,
    padding: '8px',
    textAlign: 'center'
}
const TABS = Object.keys(TYPES).map(key => {
    return {
        key,
        name: TYPES[key]
    }
})

const windowWidth = document.documentElement && document.documentElement.clientWidth ? document.documentElement.clientWidth : document.body.clientWidth

const ratio = windowWidth / 750

const DEFAULT_TAB_HEIGHT = 200

const SCHOOL_TAB_HEIGHT = DEFAULT_TAB_HEIGHT + 86

const SCROLL_VIEW_HEIGHT = 375

export default {
    mixins: [
        log_mixins('周边配套'),
        consult
    ],
    data () {
        return {
            title: '',
            house: {},
            markers: [],
            category: 'metro',
            tabs: TABS,
            audio_url: '',
            items: [],
            selected_index: -1,
            school_tabs: ['全部', '中学', '小学', '幼儿园'],
            school_type: '全部',
            footer_class: 'min',
            last_direction: 'min',
            loading: true
        }
    },
    async created () {
        const { id, category, type } = this.$route.query
        this.category = category || ''
        if (this.type === 'business') {
            this.house = await BusinessBuildingService.get(id)
        } else {
            this.house = await BuildingService.getBuilding(id)
        }
        const locations = this.house.location  ? this.house.location.split(',') : []
        this.title = `${this.house.name}-周边配套`
        if (locations.length) {
            this.house.longitude = Number(locations[0])
            this.house.latitude = Number(locations[1])
        }
        MapData.HouseMarker = {
            ...this.house,
            iconPath: HOUSE_ICON,
            title: this.house.name,
            zIndex: 2,
            width: 22,
            height: 37,
            type: 'house',
            callout: {
                content: this.house.name,
                ...MAIN_CALLOUT
            }
        }
        this.getData()
    },
    destroyed () {
        MapData.reset()
        PageData = {}
    },
    methods: {
        goFeedBack() {
            sendCtmEvtLog('周边配套-反馈')
            this.$router.push({
                path:`/personal_package/feedback/main`
            })
        },
        resetMarker () {
            console.error(this.selected_index)
            if (this.selected_index > -1) {
                const marker = this.markers[this.selected_index]
                this.$set(this.markers, this.selected_index, {
                    ...marker,
                    iconPath: DETS_ICONS[TYPES[this.category]] || DEFAULT_DEST_ICON,
                    callout: {
                        ...marker.callout,
                        ...NORMAL_CALLOUT,
                        content: marker.title
                    }
                })
            }
        },
        async getData () {
            this.loading = true
            const { id } = this.$route.query
            let items = PageData[this.category]
            this.markers = [MapData.HouseMarker]
            if (items && !this.school_type) {
                this.getMarkers(items)
            } else {
                if (this.category === '') return
                let data = {}
                if (this.category === 'building') {
                    data = await BuildingService.getBuildings({
                        feature: '附近楼盘',
                        building_id: id,
                        page: 1,
                        per: 20
                    })
                    data.items = data.items.map(mapHouseItem)
                } else {
                    const params = {
                        page: 1,
                        category: this.category
                    }
                    if (this.category === 'school') {
                        params.subcategory = this.school_type
                    }
                    data = await Service.getAcround(id, params)
                    this.audio_url = data.audio_url
                }
                items = data.items
                if (!items || items.length === 0) {
                    const type = TYPES[this.category]
                    this.items = []
                    this.$wx.showToast({
                        title: `3公里以内暂无${type}`,
                        icon: 'none',
                        duration: 3000
                    })
                    this.loading = false
                    return
                }
                items.forEach((item) => {
                    if(item.distance >= 1000) {
                        item.distance = (item.distance / 1000).toFixed(1) + 'km'
                    } else {
                        item.distance = item.distance + 'm'
                    }
                })
                PageData[this.category] = items
                this.loading = false
            }
            this.getMarkers(items)
            if (this.category && this.footer_class === 'normal') {
                this.showList()
            }
            this.loading = false
        },
        getMarkers (items) {
            this.items = items
            const show_callout = this.category === 'building'
            setTimeout(() => {
                this.markers = [
                    MapData.HouseMarker,
                    ...items.map((item, i) => {
                        const locations = item.location.split(',').map(item => Number(item))
                        const _callout = {
                            content: item.name,
                            ...NORMAL_CALLOUT
                        }
                        return {
                            id: `${item.name}-${i}`,
                            title: item.name,
                            longitude: locations[0],
                            latitude: locations[1],
                            iconPath: DETS_ICONS[TYPES[this.category]] || DEFAULT_DEST_ICON,
                            zIndex: 1,
                            width: 27,
                            height: 32,
                            _callout,
                            highlight: false,
                            callout: show_callout ? _callout : null
                        }
                    })
                ]
                this.getPoints()
            }, 300)
        },
        goConsultant () {
            const { id } = this.$route.query
            this.$clickLog('立即咨询点击')
            this.$router.push({
                path:`/consultants/filter/main?id=${id}`
            })
        },
        changeType (e) {
            const { key, name } = e.currentTarget.dataset
            this.category = key
            this.selected_index = 10000
            setTimeout(() => {
                this.selected_index = -1
            })
            this.$clickLog(name)
            this.getData()
        },
        getPoints () {
        },
        moveLocation (longitude, latitude) {
        },
        clickMarker ({ markerId }) {
            console.log('markerId', markerId)
            this.markers.forEach((item, i) => {
                if (item.type !== 'house') {
                    if (item.highlight) {
                        this.cancelHighlight(item, i)
                    } else if (item.id == markerId) {
                        this.highlightMarker(item, i)
                        this.changeSelectIndex(item)
                    }
                }
            })
            this.showList()
        },
        changeSelectIndex (marker) {
            this.items.some((item, i) => {
                if (item.name === marker.title) {
                    this.selected_index = i
                    return true
                }
            })
        },
        highlightMarker (item, index) {
            const type = TYPES[this.category]
            item = {
                ...item,
                iconPath: DETS_A_ICONS[type],
                zIndex: 3,
                highlight: true,
                callout: {
                    ...item._callout,
                    bgColor: '#FF5C35',
                    boxShadow: '0 1px 2px 0 rgba(16, 87, 68, .3)'
                }
            }
            this.$set(this.markers, index, item)
            this.moveLocation(item.longitude, item.latitude)
        },
        cancelHighlight (item, index) {
            const type = TYPES[this.category]
            const show_callout = this.category === 'building'
            const callout = show_callout ? item._callout : null
            console.error('cancel', callout)
            item = {
                ...item,
                highlight: false,
                callout,
                iconPath: DETS_ICONS[type],
                zIndex: 1
            }
            this.$set(this.markers, index, item)
        },
        onSelect (i) {
            const { name } = this.items[i]
            const { markers } = this
            const type = TYPES[this.category]
            markers.forEach((item, i) => {
                if (item.title === name) {
                    this.highlightMarker(item, i)
                } else if (item.type !== 'house' && item.callout){
                    this.cancelHighlight(item, i)
                }
            })
            this.selected_index = i
        },
        toggleMovable () {
            if (this.footer_class === 'min' || this.footer_class === 'max') {
                this.showList()
            } else  {
                if (this.last_direction === 'min') {
                    this.showMax()
                } else {
                    this.hideList()
                }
            }
        },
        changeFooterClass (classname) {
            this.footer_class = classname
            if (classname !== 'normal') {
                this.last_direction = classname
            }
            setTimeout(this.getPoints, 600)
        },
        showMax () {
            this.changeFooterClass('max')
        },
        showList () {
            this.changeFooterClass('normal')
        },
        hideList () {
            this.changeFooterClass('min')
        },
        selectSchoolType (school_type) {
            this.school_type = school_type
            this.getData()
        }
    },
    components: {
        PoiList,
        QqMap,
        ConsultTip
    }
}
